import { h, Component } from 'preact';
import * as THREE from 'three';

export default class BackgroundStars extends Component {

	constructor(props) {
		super(props);

		this.props = props;
		const { scene, imageRoot, windowWidth } = props;
		this.scene = scene;
		this.imageRoot = imageRoot;
		this.stars = [];
		this.composer;
		this.windowWidth = windowWidth;

		this.createStars = this.createStars.bind(this);
		this.updateStars = this.updateStars.bind(this);
		this.resize = this.resize.bind(this);
	}

	async init() {
		const texture = await this.loadTexture(`${this.imageRoot}/up/qa5ofd.webp`);
		this.createStars(texture);
	}

	loadTexture(url) {
		return new Promise((resolve, reject) => {
			new THREE.TextureLoader().load(url, resolve, undefined, reject);
		});
	}
	
	createStars(texture) { 
		let numOfStars = 200;
		for (let i = 0; i < numOfStars; i++) {
			const starGeo = new THREE.PlaneGeometry(1, 1, 1);

			const starMat = new THREE.MeshStandardMaterial({
				color: new THREE.Color(1, 1, 1),
				map: texture, 
				emissive: 1,
				emissiveIntensity: 1,
				transparent: true,
				opacity: 1
			});

			const star = new THREE.Mesh(starGeo, starMat);
			
			let scale = 0;
			star.scale.set(scale, scale, scale);

			star.position.set((Math.random() - 0.5) * this.windowWidth, (Math.random() - 0.5) * 10, 0);

			this.stars.push(star);
			this.scene.add(star);
		}
	}

	updateStars(time) {	
		this.stars.forEach((star, index) => {
			const count = Math.abs(((time + index / this.stars.length) % 2) - 1);
			star.rotation.z += index % 2 ? 0.02 : -0.02;
			const scale = count / 30;
			star.scale.set(scale, scale, scale);
		});
	}

	resize(windowWidth) {
		this.windowWidth = windowWidth;
		this.stars.forEach((star) => {
			star.position.set((Math.random() - 0.5) * this.windowWidth, (Math.random() - 0.5) * 10, 0);
		});
	}
}